import { Action } from "redux";
import { IAuctionFilters } from "..";
import { IAuction } from "../../services";

export interface IAuctionState {
  loading?: boolean;
  data?: IAuction[];
  initialFilters?: IAuctionFilters;
  currentFilters?: IAuctionFilters;
  exceptionMessage?: string;
}

export enum AuctionActionEnum {
  FetchFiltersAndAuctionData = "@@auction/FETCH_FILTERS_AND_AUCTION_DATA",
  FetchedFiltersAndAuctionDataSuccess = "@@auction/FETCHED_FILTERS_AND_AUCTION_DATA_SUCCESS",
  FetchedFiltersAndAuctionDataFailed = "@@auction/FETCHED_FILTERS_AND_AUCTION_DATA_FAILED",
  UpdateAuctionCorridorFilterValue = "@@auction/UPDATE_AUCTION_CORRIDOR_FILTER_VALUE",
  FetchAuctionDataOnlyAction = "@@auction/FETCH_AUCTION_DATA_ONLY",
  FetchedAuctionDataOnlySuccess = "@@auction/FETCHED_AUCTION_DATA_ONLY_SUCCESS",
  FetchedAuctionDataOnlyFailed = "@@auction/FETCHED_AUCTION_DATA_ONLY_FAILED",
  UpateAuctionInterconnectorFilterValue = "@@auction/UPDATE_AUCTION_INTERCONNECTOR_FILTER_VALUE",
  UpateAuctionProductFilterValue = "@@auction/UPDATE_AUCTION_PRODUCT_FILTER_VALUE",
  UpateAuctionBidStatusFilterValue = "@@auction/UPDATE_AUCTION_BID_STATUS_FILTER_VALUE",
  UpateAuctionIsShowFilterValue = "@@auction/UPDATE_AUCTION_IS_SHOW_FILTER_VALUE",
  UpdateAuctionExchangeFilterValue = "@@auction/UPDATE_AUCTION_EXCHANGE_FILTER_VALUE",
  UpdateAuctionWithBidResultAction = "@@auction/UPDATE_AUCTION_WITH_BID_RESULT",
  UpdateAuctionWithBidResultSuccessAction = "@@auction/UPDATE_AUCTION_WITH_BID_RESULT_SUCCESS",
  FetchAuctionDataOnlyWithoutDateAction = "@@auction/FETCH_AUCTION_DATA_ONLY_WITHOUT_DATE",
  FetchAuctionDataOnlyWithoutDateNoUpateAction = "@@auction/FETCH_AUCTION_DATA_ONLY_WITHOUT_DATE_NO_UPDATE",
}

export interface IFetchFiltersAndAuctionAction
  extends Action<typeof AuctionActionEnum.FetchFiltersAndAuctionData> {
  state?: IAuctionState;
}

export interface IUpdateAuctionWithBidResultsAction
  extends Action<typeof AuctionActionEnum.UpdateAuctionWithBidResultAction> {
  state?: IAuctionState;
}

export interface IUpateAuctionBidStatusFilterValueAction
  extends Action<typeof AuctionActionEnum.UpateAuctionBidStatusFilterValue> {
  state?: IAuctionState;
}

export interface IUpdateAuctionWithBidResultSuccessAuction
  extends Action<
    typeof AuctionActionEnum.UpdateAuctionWithBidResultSuccessAction
  > {
  state?: IAuctionState;
}

export interface IFetchedFiltersAndAuctionDataSuccessAction
  extends Action<typeof AuctionActionEnum.FetchedFiltersAndAuctionDataSuccess> {
  state?: IAuctionState;
}

export interface IFetchedFiltersAndAuctionDataFailedAction
  extends Action<typeof AuctionActionEnum.FetchedFiltersAndAuctionDataFailed> {
  state?: IAuctionState;
}

export interface IUpdateAuctionCorridorFilterValueAction
  extends Action<typeof AuctionActionEnum.UpdateAuctionCorridorFilterValue> {
  state?: IAuctionState;
}

export interface IUpdateAuctionProductFilterValueAction
  extends Action<typeof AuctionActionEnum.UpateAuctionProductFilterValue> {
  state?: IAuctionState;
}

export interface IUpdateAuctionIsShowFilterValueAction
  extends Action<typeof AuctionActionEnum.UpateAuctionIsShowFilterValue> {
  state?: IAuctionState;
}

export interface IUpdateAuctionInterconnectorFilterValueAction
  extends Action<
    typeof AuctionActionEnum.UpateAuctionInterconnectorFilterValue
  > {
  state?: IAuctionState;
}

export interface IUpdateAuctionExchangeFilterValueAction
  extends Action<typeof AuctionActionEnum.UpdateAuctionExchangeFilterValue> {
  state?: IAuctionState;
}

export interface IFetchAuctionDataOnlyAction
  extends Action<typeof AuctionActionEnum.FetchAuctionDataOnlyAction> {
  state?: IAuctionState;
}

export interface IFetchedAuctionDataOnlySuccessAction
  extends Action<typeof AuctionActionEnum.FetchedAuctionDataOnlySuccess> {
  state?: IAuctionState;
}

export interface IFetchedAuctionDataOnlyFailedAction
  extends Action<typeof AuctionActionEnum.FetchedAuctionDataOnlyFailed> {
  state?: IAuctionState;
}

export interface IFetchedAuctionDataOnlyWithoutDateAction
  extends Action<
    typeof AuctionActionEnum.FetchAuctionDataOnlyWithoutDateAction
  > {
  state?: IAuctionState;
}

export type AuctionActions =
  | IFetchFiltersAndAuctionAction
  | IFetchedFiltersAndAuctionDataSuccessAction
  | IFetchedFiltersAndAuctionDataFailedAction
  | IUpdateAuctionCorridorFilterValueAction
  | IFetchAuctionDataOnlyAction
  | IFetchedAuctionDataOnlyFailedAction
  | IFetchedAuctionDataOnlySuccessAction
  | IUpdateAuctionInterconnectorFilterValueAction
  | IUpdateAuctionProductFilterValueAction
  | IUpdateAuctionIsShowFilterValueAction
  | IUpdateAuctionExchangeFilterValueAction
  | IUpdateAuctionWithBidResultsAction
  | IUpdateAuctionWithBidResultSuccessAuction
  | IUpateAuctionBidStatusFilterValueAction
  | IFetchedAuctionDataOnlyWithoutDateAction;
